import { render, staticRenderFns } from "./BreakdownTable.vue?vue&type=template&id=0fbc2cb3&scoped=true&"
import script from "./BreakdownTable.vue?vue&type=script&lang=ts&"
export * from "./BreakdownTable.vue?vue&type=script&lang=ts&"
import style0 from "./BreakdownTable.vue?vue&type=style&index=0&id=0fbc2cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc2cb3",
  null
  
)

export default component.exports